/* Oath blog hub, v1.25.7 (Oct 2026): library filter, dropdown controls, hero search, current birthstone month. No dependencies. */
(function () {
  var lib = document.getElementById('ojb-library');

  // Current birthstone month (corrects a cached server render at month boundaries; class only, no layout shift)
  var m = new Date().getMonth();
  var bs = document.querySelectorAll('[data-ojb-bs] [data-m]');
  for (var i = 0; i < bs.length; i++) {
    var on = +bs[i].getAttribute('data-m') === m;
    bs[i].classList.toggle('is-now', on);
    if (on) { bs[i].setAttribute('aria-current', 'date'); } else { bs[i].removeAttribute('aria-current'); }
  }

  if (!lib) { return; }
  var accs = [].slice.call(lib.querySelectorAll('.ojb-acc'));
  var input = lib.querySelector('[data-ojb-filter]');
  var count = lib.querySelector('[data-ojb-count]');
  var heroForm = document.querySelector('[data-ojb-search]');
  var heroInput = heroForm && heroForm.querySelector('input[name="q"]');

  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  accs.forEach(function (a) {
    a._items = [].slice.call(a.querySelectorAll('li'));
    a._total = a._items.length;
    a._n = a.querySelector('[data-ojb-n]');
    a._items.forEach(function (li) { var x = li.querySelector('a'); x._t = x.textContent; });
  });

  function filter(raw) {
    var q = (raw || '').trim().toLowerCase();
    var total = 0;
    accs.forEach(function (a) {
      var hits = 0;
      a._items.forEach(function (li) {
        var x = li.querySelector('a'), t = x._t;
        var ok = !q || (li.getAttribute('data-s') || '').indexOf(q) > -1;
        li.hidden = !ok;
        if (ok) { hits++; }
        var k = q ? t.toLowerCase().indexOf(q) : -1;
        if (k > -1) { x.innerHTML = esc(t.slice(0, k)) + '<mark>' + esc(t.slice(k, k + q.length)) + '</mark>' + esc(t.slice(k + q.length)); }
        else if (x.firstElementChild) { x.textContent = t; }
      });
      a.hidden = !!q && !hits;
      a.open = !!q && hits > 0;
      if (a._n) { a._n.textContent = q ? hits : a._total; }
      total += hits;
    });
    if (!q) { count.textContent = ''; }
    else { count.textContent = total ? total + (total === 1 ? ' guide matches “' : ' guides match “') + raw.trim() + '”' : 'No guides match “' + raw.trim() + '”. Try a stone, metal or occasion.'; }
    return total;
  }

  var t;
  input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { filter(input.value); }, 120); });

  if (heroForm && heroInput) {
    heroForm.addEventListener('submit', function (e) {
      var q = heroInput.value.trim();
      if (!q) { e.preventDefault(); heroInput.focus(); return; }
      input.value = q;
      if (filter(q) > 0) {
        e.preventDefault();
        lib.scrollIntoView({ block: 'start' });
        input.focus({ preventScroll: true });
      }
      // No match in the library: let the form submit to site search (articles).
    });
  }

  lib.querySelector('[data-ojb-expand]').addEventListener('click', function () { accs.forEach(function (a) { if (!a.hidden) { a.open = true; } }); });
  lib.querySelector('[data-ojb-collapse]').addEventListener('click', function () { accs.forEach(function (a) { a.open = false; }); });

  // "All N guides" links and the Buying, Style & Craft chip open their dropdown
  document.addEventListener('click', function (e) {
    var l = e.target.closest && e.target.closest('[data-ojb-open]');
    if (!l) { return; }
    var a = document.getElementById(l.getAttribute('data-ojb-open'));
    if (!a) { return; }
    e.preventDefault();
    if (input.value) { input.value = ''; filter(''); }
    a.open = true;
    a.scrollIntoView({ block: 'start' });
    var s = a.querySelector('summary');
    if (s) { s.focus({ preventScroll: true }); }
    if (history.replaceState) { history.replaceState(null, '', '#' + a.id); }
  });

  // Deep link to a dropdown (#ojb-lib-gems) opens it
  if (location.hash.indexOf('#ojb-lib-') === 0) {
    var d = document.getElementById(location.hash.slice(1));
    if (d && d.tagName === 'DETAILS') { d.open = true; }
  }
})();
